import { StyleSheet } from 'aphrodite/no-important';
import { iconUrl } from '../../shared/styles/vars';
import { color, fontWeight } from '../../shared/styles/vars';
import { media } from '../../shared/styles/constants';
export const styles = StyleSheet.create({ 
    mvpdContent: {
        width: "100%",
        height: "100%",
        position: 'fixed',
        top: 0,
        zIndex: 999991,
        backgroundColor:  color.white,
        [media.AT_LEAST_LAPTOP]: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }
    },
    mvpdWrapper: {
        width: '100%',
        height: '100%',
        backgroundColor: color.white,
        position: 'inherit',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        [media.AT_LEAST_LAPTOP]: {
            width: 800,
            height: 628,
        }

    },
    btnClose: {
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: color.white,
        cursor: "pointer",
        height: "44px",
        justifyContent: "center",
        width: "44px",
        border: "none",
        position: "absolute",
        right: "0",
        top: "0",
        outline: 'none',
    },
    close: {
        display: "inline-flex",
        borderBottomColor: color.black,
        borderTopColor: color.black,
        opacity: "0.7",
        height: "9px",
        width: "22px",
        ':before': {
            transform: "rotate(45deg)",
            backgroundColor: "black",
            content: "''",
            height: "1px",
            marginTop: "3px",
            position: "absolute",
            width: "22px"
        },
        ':after': {
            transform: "rotate(-45deg)",
            backgroundColor: "black",
            content: "''",
            height: "1px",
            marginTop: "3px",
            position: "absolute",
            width: "22px"
        }
    },
    mpvdContentTitle: {
        display: "block",
        fontSize: 40,
        fontWeight: "bold",
        color: "#002e56",
        width: "100%",
        marginTop: 40,
        marginBottom: 24,
        [media.MOBILE]: {
            marginBottom: 10,
            fontSize: 26,
            marginTop: 70,
        }

    },
    mpvdContentDesc: {
        display: "block",
        opacity: "0.7",
        fontSize: "16px",
        fontWeight: "500",
        color: "#002e56",
        marginBottom: 24,
        
        [media.MOBILE]: {
            fontSize: 12,
        }
    },
    authedChannels: {
        display: "flex",
        width: "100%",
        position: "relative",
        flexWrap: "wrap",
        [media.AT_LEAST_TABLET]: {
            width: 655,
            margin: '0 auto',
        }
    },
    authedChannel: {
        flex: "1 0 23%",
    },
    iCheckMark: {
        backgroundImage: `url(${iconUrl.icCheckMark})`,
        display: 'inline-block',
        width: 45,
        height: 45,
    },
    channelImg: {
        width: 138,
        [media.MOBILE]: {
            width: 80
        }
    },
    channelsWrapper: {
        width: 655,
        margin: '0 auto',
        [media.MOBILE_OR_TABLET]: {
            width: '100%'
        }
    }

});